export const SPONSORSHIP_PATH = "/parrainage";
export const SPONSORSHIP_RECOMMENDATIONS_PATH = `${SPONSORSHIP_PATH}/recommandations`;
export const SPONSORSHIP_CONVERSIONS_PATH = `${SPONSORSHIP_PATH}/conversions`;
export const SPONSORSHIP_HOW_IT_WORKS_PATH = `${SPONSORSHIP_PATH}/comment-ca-marche`;
